import { useNavigate } from "react-router-dom";
import { Dialog, List, ListItemButton, ListItemText } from "@mui/material";

export interface ActionDialogActions {
  handler: () => Promise<void>;
  label: string;
}

export interface ActionsDialogProps {
  actions: ActionDialogActions[];
  onClose: () => void;
  open: boolean;
}

function ActionsDialog(props: ActionsDialogProps) {
  const { actions, onClose, open } = props;
  const navigate = useNavigate();

  const handleListItemClick = async (handler: () => Promise<void>): Promise<void> => {
    await handler();
    onClose();
  };

  return (
    <Dialog onClose={() => navigate(-1)} open={open}>
      <List>
        {actions.map((action) => (
          <ListItemButton key={action.label} onClick={() => handleListItemClick(action.handler)}>
            <ListItemText primary={action.label} />
          </ListItemButton>
        ))}
      </List>
    </Dialog>
  );
}

export default ActionsDialog;
